// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__aUlRZ","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2M7qk"};